import React, {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';

import {SecondaryTabs, Tab} from '@pb/kit-component-tabs-v2';


type Props = {
    userId: number,
    activeTab: string,
};

export const PersonalizationTabs = ({userId, activeTab}: Props) => {
    const navigate = useNavigate();

    const changeTab = useCallback((tab: string) => {
        navigate(`/profile/user/${userId}/personalization/${tab}`);
    }, [userId, navigate]);

    return (
        <SecondaryTabs value={activeTab} onChange={changeTab} className="level-2-tabs" style={{width: '100%'}}>
            <Tab caption="View & Preferences" value="view-preferences"/>
            <Tab caption="Activity Tags" value="activity-tags"/>
            <Tab caption="LCD Credit Analysis" value="lcd-credit-analysis"/>
        </SecondaryTabs>
    );
};
